import { NgModule } from "@angular/core";
import { FormControlsModule } from "./form-controls.module";

/**
 * Módulo compartido para reutilizar controles de formulario en otros módulos.
 * Importa y exporta FormControlsModule.
 */
@NgModule({
	imports: [FormControlsModule],
	exports: [FormControlsModule],
})
export class SharedFormControlsModule {}
